import React from "react";
import * as moment from "moment";
import DayEnToFr from "../../utils/DayEnToFr";
import { useBestOf } from "../../context/BestOf";
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  buttonFilter: {
    backgroundColor: theme.palette.background.paper,
    fontSize: "15px",
    borderRadius: "5px",
    margin: "10px 0px",
    cursor: "pointer"
  }
}));

const FilterDay = ({ day }: { day: string }) => {
  const classes = useStyles();
  const {dispatch} = useBestOf();

  let date = moment.utc(day).format("dddd");
  let dateNum = moment.utc(day).format("DD/MM");
  return (
    <Button variant="outlined" className={classes.buttonFilter} onClick={() => dispatch({type: "UPDATE_DAY_PICKED", payload: { datePicked: day}})}>
      {DayEnToFr(date)} {dateNum}
    </Button>
  );
};

export default FilterDay;
